import React from 'react';

export const DashboardLayout = {
  layout1: React.lazy(() => import('./Layout/Layout'))
};
